module.exports = __webpack_public_path__ + "img/mode-test--icon--active.97f0a0d5.svg";